import React, {Component} from "react";
import {ControlPanelService} from "../../../service/controlPanel/ControlPanelService";
import RestrictionGuaranteeSelection from "./RestrictionGuaranteeSelectionView";
import {CONTROL_PANEL_ROUTE} from "../../../utils/constants/RoutesConstants";

export default class RestrictionGuaranteeSelectionContainer extends Component {
    constructor(props) {
        super(props);

        this.controlPanelService = new ControlPanelService();

        this.loading = this.loading.bind(this);
        this.handleReturnButton = this.handleReturnButton.bind(this);
        this.saveCheck = this.saveCheck.bind(this);
        this.updateGuaranteeSelectionRestriction = this.updateGuaranteeSelectionRestriction.bind(this);

        this.state = {
            isLoading: true,
            loanId: this.props.location.state.folio,
            selectedLoan: this.props.location.state.selectedLoanControlPanel,
            isRestricted: this.props.location.state.seleccionGaran === 1,
        }
    };

    loading(isLoading) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: isLoading
            });
        }
    }

    handleReturnButton() {
        this.props.history.push({
            pathname: CONTROL_PANEL_ROUTE,
        });
    }

    saveCheck(event) {
        const {name, checked} = event.target;
        this.setState({[name]: checked,})
    }

    updateGuaranteeSelectionRestriction() {
        this.loading(true);
        this.controlPanelService.updateGuaranteeSelectionRestriction(
            this.state.loanId,
            this.state.isRestricted ? 1 : 0
        )
            .then(response => {
                this.handleReturnButton();
            });
    }

    render() {
        return <RestrictionGuaranteeSelection
            isLoading={this.state.isLoading}
            loading={this.loading}
            loanId={this.state.loanId}
            selectedLoan={this.state.selectedLoan}
            handleReturnButton={this.handleReturnButton}
            saveCheck={this.saveCheck}
            isRestricted={this.state.isRestricted}
            updateGuaranteeSelectionRestriction={this.updateGuaranteeSelectionRestriction}
        />

    }
};